import React from 'react';
import axios from 'axios';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { signOut } from '@ordermentum/ui-shared/utilities';
import { Location } from '@ordermentum/ui-definitions';
import { UserFlags, User } from '@ordermentum/ui-types';
import {
  Container,
  ContentContainer,
  Header,
  TextContainer,
  Text,
  Subtitle,
  SignedInText,
} from '../Shared/Container.style';
import { CardFixedWidth } from '../Card';
import Background from '../Background';
import { UserForm } from '../Shared/Form/UserForm';
import {
  TrackEvent,
  trackEvent as trackEventAction,
} from '../Analytics/redux/actions';
import { TRACK_EVENT_FORM_SUBMISSION } from '../Analytics/redux/constants';
import { BusinessForm } from './Form/BusinessForm';
import { changeWindowLocation } from '../../lib/utilities';
import { RootState } from '../../redux/store';

type Props = {
  trackEvent: TrackEvent;
  location: Location;
  user?: User;
  flags?: UserFlags;
  fetchFlagsAsync: Function;
};

const RetailerRegisterForms = (props: Props) => {
  const { user, location, trackEvent } = props;
  return (
    <Background>
      <CardFixedWidth>
        {user?.email ? (
          <>
            <SignedInText>
              Logged in as {user.email}. Not you?{' '}
              <a
                onClick={signOut}
                onKeyPress={signOut}
                role="link"
                tabIndex={0}
              >
                Sign Out
              </a>
            </SignedInText>
            <ContentContainer>
              <Container>
                <Header>
                  Get access to the largest network of suppliers in Australia
                </Header>
                <TextContainer>
                  <Text>
                    Complete the form below to create your venue on Ordermentum
                    and connect to suppliers across Australia
                  </Text>
                </TextContainer>
              </Container>
              <BusinessForm user={user} />
            </ContentContainer>
          </>
        ) : (
          <ContentContainer>
            <Container>
              <Header>Great news!</Header>
              <TextContainer>
                <Text>Using Ordermentum is 100% free for retailers.</Text>
                <Text>
                  <span>
                    Already have an account? <a href="/signin">Sign in.</a>
                  </span>
                </Text>
              </TextContainer>
              <Subtitle>Sign up:</Subtitle>
            </Container>
            <UserForm
              location={location}
              trackEvent={trackEvent}
              onSubmit={async ({ firstName, lastName, email, phone }) => {
                try {
                  const campaign = location?.query?.campaign ?? 'app-sign-up';
                  trackEvent({
                    event: TRACK_EVENT_FORM_SUBMISSION,
                    type: 'user-form-submission',
                    properties: {
                      campaign,
                    },
                  });
                  await axios.post('/v1/register', {
                    first_name: firstName,
                    last_name: lastName,
                    email,
                    phone,
                    campaign,
                    source: 'retailer',
                  });
                  changeWindowLocation('/register/retailer/success');
                } catch (err) {
                  changeWindowLocation('/register/retailer/failure');
                }
              }}
            />
          </ContentContainer>
        )}
      </CardFixedWidth>
    </Background>
  );
};

const RetailerRegister = (props: Props) => RetailerRegisterForms(props);

const mapStateToProps = (state: RootState) => ({
  user: state?.profile?.data || {},
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      trackEvent: trackEventAction,
    },
    dispatch
  );

export const RetailerRegisterConnected = connect(
  mapStateToProps,
  mapDispatchToProps
)(RetailerRegister);
